export default __webpack_public_path__ + "static/media/Sigga.61de7367.png";